import React from 'react';


const WiderThree = ()=> {
    return (
        <React.Fragment>
            <div className="vertWideC_60 Lmask"></div>
            <div className="vertWideC_60 Rmask"></div>
            <div className="vertWideC_60 Lframe"></div>
            <div className="vertWideC_60 Midframe"></div>
            <div className="vertWideC_60 Rframe"></div>
        </React.Fragment>
    )
}


export default WiderThree;